<template lang="pug">
    model-form(
        loading-text='Cargando nota de debito...'
        ref='form'
        no-submit
        reset-text='refrescar'
        submit-text='guardar'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submitUpdate'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import SaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'
    import SaleDebitNoteFields from '@/views/Sale/SlSaleDebitNote/SlSaleDebitNoteFields'
    //
    export default {
        name: 'sale-debit-note-update',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            formProps() {
                return {
                    //editable: false,
                    fields: SaleDebitNoteFields.variant('update').readonly(),
                    loading: this.busy,
                    //switchEdit: true,
                    title: this.formTitle,
                }
            },

            /**
             * 
             */
            formTitle() {
                return `Nota de debito #${this.$route.params.id}`
            },
        },
        data() {
            return {
                busy: false,
                formData: {},
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(SaleDebitNoteModel, error.response.data))
            },

            /**
             * 
             */
            fetch() {
                return SaleDebitNoteModel.modeler().find(this.$route.params.id).then(this.setFormData)
            },

            /**
             * 
             */
            reset() {
                this.setBusy(true).then(this.fetch).then(this.setBusy)
            },

            /**
             * 
             */
            async setBusy(busy = false) {
                this.busy = busy
            },

            /**
             * 
             */
            setFormData(model) {
                this.formData = model.reset()
            },

            /**
             * 
             */
            submitUpdate() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toUpdate)
                    .catch(this.error)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            successUpdate() {
                this.setSuccessSnackbar('Nota de debito actualizado exitosamente.')
            },

            /**
             *
             */
            toUpdate(model) {
                return model
                    .toUpdate()
                    .save()
                    .then(this.successUpdate)
                    .then(this.reset)
            },
        },
        mounted() {
            this.setTitleTopBar('Detalle nota de debito').then(this.reset)
        },
    }
</script>